import CartDetails from "@/components/cart/details/details";
import ProductCard from "@/components/product-card/product-card";
import Layout from "@/layout/layout";
import { wrapper } from "@/store";
import { setMeta, setOg, setPath, setTitle } from "@/store/slices/helmet";
import { selectWishlist } from "@/store/slices/wishlist";
import styles from "@/styles/cart.module.scss";
import Link from "next/link";
import React, { ReactElement, useEffect } from "react";
import { useSelector } from "react-redux";
import { unbxdCusEngTrackEvent } from "@/lib/unbxd";

const Wishlist = () => {
  const wishlistState = useSelector(selectWishlist);
  useEffect(() => {
    setTimeout(() => {
        unbxdCusEngTrackEvent("Wishlist items ", {
          source: "web",
          platform: "senco",
          total_prqt: wishlistState.items.length,
          items: wishlistState.items?.map((v) => ({
            prid: v.id,
            prqt: 1,
            variant_id: v.priceId,
            image: v.image,
            product_name: v.title,
            category: v.categories?.length
              ? [...v.categories].reverse()[0]?.name
              : "",
            product_url: `${process.env.NEXT_PUBLIC_APP_URL}/jewellery/${v.slug}`,
            selling_price: v.price,
            discounted_price: v.discount?.price,
          })),
        });
    }, 500);
  }, [wishlistState]);

  return (
    <section className={styles.cart_page}>
      <div className="container">
        <div className="row mt-5 mb-5">
          <div className="col-md-12 mb-3">
            <h4 className="text-center">WISHLIST</h4>
          </div>
          {wishlistState.items.length ? (
            <>
              {wishlistState.items.map((product) => (
                <div className="col-lg-3 col-md-6 col-6" key={product.id}>
                  <ProductCard product={product} />
                </div>
              ))}
            </>
          ) : (
            <div className="col-12">
              <p className="text-center">Your wishlist is empty</p>
              <p className="text-center">
                <Link href="/" passHref>
                  <button
                    aria-label=" Continue Shopping"
                    role="button"
                    className="btn btn-outline-info"
                  >
                    Continue Shopping
                  </button>
                </Link>
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

Wishlist.getLayout = (page: ReactElement) => {
  return <Layout>{page}</Layout>;
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) =>
    async ({ resolvedUrl }) => {
      store.dispatch(setPath(resolvedUrl));
      store.dispatch(setTitle("Wishlist"));
      store.dispatch(
        setMeta({
          title: "Wishlist | Senco Gold & Diamonds",
          description:
            "List all the jewellery pieces you want to buy on Senco's wishlist. Save time. Check Price and Shop Online from senco gold and diamonds.",
          keywords: "",
        })
      );
      store.dispatch(
        setOg({
          type: "website",
          url: `${process.env.NEXT_PUBLIC_APP_URL}${resolvedUrl}`,
          title: "Wishlist | Senco Gold & Diamonds",
          description:
            "List all the jewellery pieces you want to buy on Senco's wishlist. Save time. Check Price and Shop Online from senco gold and diamonds.",
          image: "",
        })
      );
      return {
        props: {},
      };
    }
);

export default Wishlist;
